import {FormElementValues} from "@xal3xfx/react-utils";

const email: FormElementValues<'multiselect'> = {
    type: "multiselect",
    label: 'email',
    props: { maxSelectedLabels: 1 },
    options: []
}

export const formElements = {
    email
}
